import { Box, Button, Paper, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

export function FlowBuilderError({ error, onBack, onRetry, retrying = false }) {
  const { t } = useTranslation();
  const status = error?.response?.status;
  const reason = status === 403 ? "accessDenied" : status === 404 ? "unavailable" : "loadFailed";
  const canRetry = reason === "loadFailed" && Boolean(onRetry);

  return (
    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", p: 3 }}>
      <Paper
        component="section"
        role="alert"
        elevation={0}
        sx={{ width: "100%", maxWidth: 480, p: 3, border: 1, borderColor: "divider", borderRadius: 2, textAlign: "center" }}
      >
        <Typography component="h2" variant="h6" sx={{ mb: 1 }}>
          {t(`flows.builderError.${reason}Title`)}
        </Typography>
        <Typography color="text.secondary" variant="body2">
          {t(`flows.builderError.${reason}Description`)}
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 1, mt: 3 }}>
          {canRetry && (
            <Button variant="contained" onClick={onRetry} disabled={retrying}>
              {t("common.retry")}
            </Button>
          )}
          <Button variant={canRetry ? "outlined" : "contained"} onClick={onBack}>
            {t("flows.backToFlows")}
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}
